export default __webpack_public_path__ + "static/media/location-marker.d958a2ae.svg";